import React, { createContext, useContext, useState } from 'react';

const TooltipContext = createContext();

export const useTooltip = () => {
  const context = useContext(TooltipContext);
  if (!context) {
    throw new Error('useTooltip deve ser usado dentro de um TooltipProvider');
  }
  return context;
};

export const TooltipProvider = ({ children }) => {
  const [tooltips, setTooltips] = useState({});

  const showTooltip = (id, content, position = 'top') => {
    setTooltips(prev => ({
      ...prev,
      [id]: { content, position, visible: true },
    }));
  };

  const hideTooltip = id => {
    setTooltips(prev => ({
      ...prev,
      [id]: { ...prev[id], visible: false },
    }));
  };

  const value = {
    tooltips,
    showTooltip,
    hideTooltip,
  };

  return <TooltipContext.Provider value={value}>{children}</TooltipContext.Provider>;
};
